import { Package, ShieldCheck, Globe, Lock, LucideIcon } from 'lucide-react';

export interface FeatureItem {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
}

export const featuresData: FeatureItem[] = [
  {
    id: 'custom-manufacturing',
    title: 'Custom Manufacturing',
    description: 'As per your design',
    icon: Package,
  },
  {
    id: 'premium-quality',
    title: 'Premium Quality',
    description: '100% Quality Assured',
    icon: ShieldCheck,
  },
  {
    id: 'global-shipping',
    title: 'Global Shipping',
    description: 'Worldwide Delivery',
    icon: Globe,
  },
  {
    id: 'secure-payments',
    title: 'Secure Payments',
    description: 'Safe & Secure',
    icon: Lock,
  },
];